import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MainPage } from './MainPage';
import './styles/index.css';

// Add favicon
const favicon = document.createElement('link');
favicon.rel = 'icon';
favicon.type = 'image/svg+xml';
favicon.href = 'images/favicon.svg';
document.head.appendChild(favicon);

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <StrictMode>
        <MainPage />
    </StrictMode>
);